import { Location } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { Router } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'
import { Button } from 'primeng/button'

import { LogoutStrategy } from '@ti/core/auth/services'

@Component({
  selector: 'app-access-denied-page',
  templateUrl: 'access-denied-page.component.html',
  styleUrl: 'access-denied-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, Button],
})
export class AccessDeniedPageComponent {
  protected readonly router = inject(Router)
  protected readonly location = inject(Location)
  protected readonly logoutStrategy = inject(LogoutStrategy)

  protected backToApp() {
    this.location.back()
  }

  protected async logOut() {
    return this.logoutStrategy.signOut()
  }
}
